module.exports = __webpack_public_path__ + "public-ui/img/psb.d6e30fec.svg";